import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";

export const SCORE_TONES = {
  strong: { color: "#1F7A3A", background: "rgba(31,122,58,0.10)" },
  positive: { color: "#4F7F32", background: "rgba(79,127,50,0.10)" },
  neutral: { color: "#8A6A12", background: "rgba(201,176,123,0.16)" },
  weak: { color: "#B76E22", background: "rgba(183,110,34,0.12)" },
  veryWeak: { color: "#9B2C2C", background: "rgba(155,44,44,0.10)" },
  unavailable: { color: "#6B7280", background: "rgba(107,114,128,0.10)" },
};

export const PILLAR_PRESENTATION = {
  stability: {
    icon: ShieldOutlinedIcon,
    description: "Operational and financial consistency",
    tone: "strong",
  },
  strength: {
    icon: TrendingUpIcon,
    description: "Asset quality and company strength",
    tone: "positive",
  },
  opportunity: {
    icon: SellOutlinedIcon,
    description: "Valuation and upside context",
    tone: "neutral",
  },
  risk: {
    icon: WarningAmberOutlinedIcon,
    description: "Downside and uncertainty",
    tone: "weak",
  },
};

export const METHODOLOGY_NOTE =
  "Scores are based on ResourceNAV's company, financial, asset, valuation, and risk data. Detailed methodology is under development.";

export function normalizeCompanyScorePayload(scores) {
  return {
    status: scores?.status || "unavailable",
    overall_score: scores?.overall_score ?? null,
    model_version: scores?.model_version || null,
    calculated_at: scores?.calculated_at || null,
    pillars: Array.isArray(scores?.pillars) ? scores.pillars : [],
  };
}

export function formatScore(score) {
  if (score === null || score === undefined || score === "") return "-";
  const parsed = Number(score);
  if (!Number.isFinite(parsed)) return "-";
  return parsed.toFixed(0);
}

export function getScoreProgress(score) {
  const parsed = Number(score);
  if (!Number.isFinite(parsed)) return 0;
  return Math.max(0, Math.min(100, parsed));
}

export function getScoreTone(score) {
  const parsed = Number(score);
  if (!Number.isFinite(parsed)) return SCORE_TONES.unavailable;
  if (parsed >= 80) return SCORE_TONES.strong;
  if (parsed >= 60) return SCORE_TONES.positive;
  if (parsed >= 40) return SCORE_TONES.neutral;
  if (parsed >= 20) return SCORE_TONES.weak;
  return SCORE_TONES.veryWeak;
}

export function getPillarPresentation(code) {
  return PILLAR_PRESENTATION[code] || {
    icon: AnalyticsOutlinedIcon,
    description: "",
    tone: "neutral",
  };
}

export function formatScoreDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
